import { render } from "./LectureNoteDetails.vue?vue&type=template&id=caa600d0&scoped=true"
import script from "./LectureNoteDetails.vue?vue&type=script&lang=js"
export * from "./LectureNoteDetails.vue?vue&type=script&lang=js"

import "./LectureNoteDetails.vue?vue&type=style&index=0&id=caa600d0&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa600d0"]])

export default __exports__